import React, { Component } from "react";
import { Alert } from "reactstrap";
import { MissionStep } from "./MissionStep";
import confetti from "canvas-confetti";
import {
  Mission,
  MissionService,
  MissionStep as MissionStepDto,
} from "../generated";

export interface State {
  loading: boolean;
  success: boolean;
  mission: Mission;
  current: number;
}

export class MissionControl extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      success: false,
      mission: null,
      current: 0,
    };
  }

  async componentDidMount() {
    const data = await MissionService.missionIndex();

    this.setState({
      loading: false,
      success: data.success,
      mission: data.mission,
      current: 0,
    });

    console.log(this.state);
  }

  render() {
    if (this.state.loading) return <p>Loading mission, please wait...</p>;

    if (!this.state.success)
      return (
        <Alert color="danger">
          <strong>Mission setup failed.</strong> Please try again. Your session
          might have been expired.
        </Alert>
      );

    if (this.complete())
      return (
        <Alert color="success">
          <strong>Mission accomplished</strong>
          <br />
          <br />
          Thank you for helping out, we will any feedback to make the connection
          to your provider even better.
        </Alert>
      );

    return this.renderMission(this.state.mission.steps[this.state.current]);
  }

  complete(stepNo: number = null) {
    return (stepNo || this.state.current) >= this.state.mission.steps.length;
  }

  nextStep() {
    let nextStepNo = this.state.current + 1;

    if (this.complete(nextStepNo))
      confetti({
        particleCount: 100,
        spread: 120,
        origin: {
          y: 0.6,
        },
      });

    this.setState({
      current: nextStepNo,
    });
  }

  renderMission(step: MissionStepDto) {
    return (
      <div>
        <h2>Mission Control</h2>

        <MissionStep
          type={step.type}
          presented="some data"
          context={step}
          callback={this.nextStep.bind(this)}
        />
      </div>
    );
  }
}
